module.exports = __webpack_public_path__ + "assets/successShine-837576.svg";